import WinlosesTypes from './types';
import { HostessWinlosesState, HostessWinlosesDispatchAction } from './state';
import { Reducer } from 'redux';

const initialState: HostessWinlosesState = {
    wins: '',
    loses: '',
    avg: 0,
    touch : 0,
    perfect : 0,
    chefmet : 0
}

export const WinlosesReducer : Reducer<HostessWinlosesState, HostessWinlosesDispatchAction>= 
    (state = initialState, action) => {
        switch(action.type) {
            case WinlosesTypes.FETCH_START:
                return state
            case WinlosesTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default WinlosesReducer;